import { render, staticRenderFns } from "./overview_index.vue?vue&type=template&id=f2645212&scoped=true"
import script from "./overview_index.vue?vue&type=script&lang=js"
export * from "./overview_index.vue?vue&type=script&lang=js"
import style0 from "./overview_index.vue?vue&type=style&index=0&id=f2645212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2645212",
  null
  
)

export default component.exports